/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 12.05.2016.
 */

import Share from './share';

export default Share;


// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Widgets/Share/index.js